<asw-e-ticket-emd-select-pres
  [searchType]="searchType"
  [travelerList]="travelerList"
  (clickETicketButton)="onClickETicketButton($event)"
></asw-e-ticket-emd-select-pres>
